export const MINIMUM_VERSION = '1.0.5'
